// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "i.icon.product-icon {\n  font-size: 15em;\n  width: 100%;\n  text-align: center;\n  line-height: 1;\n  vertical-align: middle;\n}\n", ""]);
// Exports
module.exports = exports;
